/*! Wi-notifications - v0.0.1
 * https://www.wicode.pl/
 * Copyright (c) 2017 Wicode; */

+function ($) {
    'use strict';
    var wiNotifications = window.wiNotifications;
    var loadNewNotifications = true;
    window.wiNotifications = {
        init: function () {
            wiNotifications.get.notifications();
            setInterval(function () {
                if (loadNewNotifications) {
                    wiNotifications.get.notifications();
                }
            }, 30000);
            wiNotifications.events();
        },
        refresh: function () {
        },
        events: function () {
            $(document).on('click', '.notifications-mark-all-as-readed', function (e) {
                e.preventDefault();
                wiNotifications.set.readed();
            });
            $(document).on('click', '.notifications-set-sections', function (e) {
                e.preventDefault();
                var r_id = $(this).data('id');
                var r_stage = $(this).data('stage');
                var r_tab = $(this).data('tab');
                var r_collapse = $(this).data('collapse');
                var r_collapseTab = $(this).data('collapse-tab');
                var r_targetId = $(this).data('target-id');
                var r_targetType = $(this).data('target-type');
                localID = 'pm-' + r_id;
                pmObject = localStorage.getItem(localID);
                if (pmObject) {
                    pmObject = JSON.parse(pmObject);
                } else {
                    pmObject = {
                        mainTab: '',
                        mainSubTab: '',
                        stageTab: '',
                        collapseTab: '',
                        collapseTabSection: '',
                        targetId: '',
                        targetType: ''
                    };
                }
                if (r_tab) {
                    pmObject.mainTab = r_tab;
                }
                if (r_stage) {
                    pmObject.stageTab = r_stage;
                }
                if (r_collapse) {
                    pmObject.collapseTab = r_collapse;
                }
                if (r_collapseTab) {
                    pmObject.collapseTabSection = r_collapseTab;
                }
                pmObject.targetId = r_targetId || '';
                pmObject.targetType = r_targetType || '';
                localStorage.setItem(localID, JSON.stringify(pmObject));
                window.location = $(this).attr('href');
            });
        },
        get: {
            notifications: function () {
                loadNewNotifications = false;
                $.get(
                        urls.notifications + '/get_notifications',
                        {
                            language_id: language_id,
                            csrf_wicode: csrf_value
                        },
                        function (data) {
                            try {
                                var area = '#notifications_area';
                                var badge = '#notifications_badge';
                                var menu = '.notifications-menu';

                                var notifications_area = $(area);
                                var notifications_badge = $(badge);
                                var notifications_menu = $(menu);

                                if ($('#notifications_area').length) {
                                    notifications_area.html(data.notifications);
                                }
                                notifications_badge.html(data.badge);
                                notifications_menu.html(data.menu);
                            } catch (e) {
                                console.error(e);
                            }
                        }
                ).always(function () {
                    wiLayout.bootstrap();
                    loadNewNotifications = true;
                });
            }
        },
        set: {
            readed: function () {
                $.post(
                        urls.notifications + '/set_readed',
                        {
                            language_id: language_id,
                            csrf_wicode: csrf_value
                        },
                        function (data) {
                            if (loadNewNotifications) {
                                wiNotifications.get.notifications();
                            }
                        }
                );
            }
        }
    };
    $(function () {
        wiNotifications = window.wiNotifications;
        wiNotifications.init();
    });
}(jQuery);
